import { IStore } from "../../../../Models/IStore";
import { IOtherInformation } from "../../../../Models/Models";
import { storeColumns } from "../Components/MyDataColumns";
import moment from "moment";
import React from "react";
import { CompanyType } from "../../../../Enums/CompanyType";

export class MyDataLogicIconStore {
  private _icons = [];
  private _iconsByColor = [];
  private _categories = [
      "education",
      "food",
      "hotel",
      "office",
      "shapes",
      "shopping",
      "travel",
  ];
  /*
    Red : #D90029
    Blue : #1B8DDF
    Green: #068D4B
    Yellow: #FFCD00
    Purple: #872F9E
    Black: #393939
    */
  private _colors = ["black", "blue", "green", "purple", "red", "yellow"];
  private _colorsHex = [
      "#393939",
      "#1B8DDF",
      "#068D4B",
      "#872F9E",
      "#D90029",
      "#FFCD00",
  ];

  private _lastChangeId = 0;

  private _getIconGroup(category, color, search) {
      let icons = null;
      if (this._icons.hasOwnProperty(category)) {
          if (this._icons[category].hasOwnProperty(color)) {
              icons = this._icons[category][color];
          }
      } else if (category === null) {
          if (this._iconsByColor.hasOwnProperty(color)) {
              icons = this._iconsByColor[color];
          }
      }

      if (icons && search) {
          const searchedIcons = [];
          search = search.toLowerCase();
          for (let i = 0; i < icons.length; i++) {
              const name = icons[i].name.toLowerCase();
              if (name.indexOf(search) > -1) {
                  searchedIcons.push(icons[i]);
              }
          }

          return searchedIcons;
      }

      return icons;
  }
  private _fnUpdateIcons(data) {
      this.setData(data);

      // var payload = new Radio.Payload();
      // payload.channel = Radio.Channels.BROADCAST;
      // payload.data = null;
      // payload.type = "cloud-icon-listing-changed";
      // Radio.broadcast(payload);
  }

  //Radio.tuneIn(_fnUpdateIcons, "cloud-icon-listing-loaded", Common.Constants.Channels.SERVER);

  public getIcons(category, color, pageNum, pageSize, searchString) {
      const icons = this._getIconGroup(category, color, searchString);
      if (icons) {
          if (icons.length > pageSize) {
              const startIndex = (pageNum - 1) * pageSize;
              return icons.slice(startIndex, startIndex + pageSize);
          }

          return icons;
      }

      return [];
  }
  public getPageNumbers(
      category,
      color,
      startPage,
      pageSize,
      maxPageDisplayCount,
      search
  ) {
      const icons = this._getIconGroup(category, color, search);
      if (icons) {
          const totalPages = Math.ceil(icons.length / pageSize);
          const actualStartPage = startPage > totalPages ? totalPages : startPage;
          const pageNumbers = [];
          let currentIndex = 0;

          let arrayIndex = 0;

          for (let i = 1; i <= totalPages; i++) {
              pageNumbers.push(i);
              if (i === actualStartPage) {
                  currentIndex = arrayIndex;
              }

              arrayIndex++;
          }

          if (maxPageDisplayCount === undefined || maxPageDisplayCount === null) {
              return pageNumbers;
          }

          if (pageNumbers.length <= maxPageDisplayCount) {
              return pageNumbers;
          }

          let startIndex = currentIndex - 1;
          if (startIndex < 0) {
              startIndex = 0;
          }

          let endIndex = startIndex + maxPageDisplayCount;
          if (endIndex > pageNumbers.length) {
              endIndex = pageNumbers.length;
          }

          while (endIndex - startIndex < maxPageDisplayCount && startIndex > 0) {
              --startIndex;
          }

          return pageNumbers.slice(startIndex, endIndex);
      }

      return [];
  }
  public getIconCount() {
      return 0;
  }
  public setData(icons) {
      this._icons = icons;
      this._iconsByColor = [];
      for (const category in this._icons) {
          if (this._icons.hasOwnProperty(category)) {
              const iconsCategory = this._icons[category];
              for (const color in iconsCategory) {
                  if (iconsCategory.hasOwnProperty(color)) {
                      const iconsColor = iconsCategory[color];
                      if (!this._iconsByColor.hasOwnProperty(color)) {
                          this._iconsByColor[color] = [];
                      }
                      for (let i = 0; i < iconsColor.length; i++) {
                          this._iconsByColor[color].push(iconsColor[i]);
                      }
                  }
              }
          }
      }
      ++this._lastChangeId;
  }
  public getLastPageNumber(category, color, pageSize, search) {
      const icons = this._getIconGroup(category, color, search);
      if (icons) {
          const count = icons.length / pageSize;
          return Math.ceil(+count);
      }

      return 0;
  }
  // public init() {
  //     // Common.Context.getCloudIcons();
  // };
  public getCategories() {
      return this._categories;
  }
  public getColors() {
      return this._colors;
  }
  public getColorsHex() {
      return this._colorsHex;
  }
  public getLastChangeId() {
      return this._lastChangeId;
  }
  public getColorHex(color) {
      const index = this._colors.indexOf(color);
      if (index > -1) {
          return this._colorsHex[index];
      }

      return null;
  }
  public getIcon(category, color, name) {
      const icons = this._getIconGroup(category, color, null);
      if (icons && icons.length) {
          for (let i = 0; i < icons.length; i++) {
              if (icons[i].name === name) {
                  return icons[i];
              }
          }
      }

      return null;
  }
  public getIconByUrl(url) {
      const components = url.split("/");
      const namePart = components.pop();
      const nameComponents = namePart.split(".");
      const name = nameComponents[0];
      const color = components.pop();
      const category = components.pop();
      return this.getIcon(category, color, name);
  }
}

export class MyDataLogicIconPager {
  private _iconStore: MyDataLogicIconStore = null;
  private _page = 1;
  private _pageSize = 100000;
  private _icons = [];
  private _categories = [];
  private _colors = [];
  private _category = null;
  private _color = null;
  private _lastPageNum = 0;
  private _pageNumbers = [];
  private _colorsName = [];
  private _colorsHex = [];
  private _lastChangeId = null;
  private _maxPageDisplayCount = undefined;
  private _searchString = null;

  public constructor(iconStore) {
      this._iconStore = iconStore;

      this._categories = ["All"].concat(this._iconStore.getCategories());
      //_categories.unshift('All');
      this._category = this._categories[0]; //--all
      //_category = _categories[5];//--shapes
      this._colorsName = this._iconStore.getColors();
      this._colorsHex = this._iconStore.getColorsHex();
      this._colors = [];

      for (let i = 0; i < this._colorsName.length; i++) {
          this._colors.push({
              name: this._colorsName[i],
              hex: this._colorsHex[i],
          });
      }

      this._color = this._colors[0];
  }

  private _getCategory = function () {
      if (this._category === "All") {
          return null;
      }

      return this._category;
  };
  private _updateIcons = function () {
      this._icons = this._iconStore.getIcons(
          this._getCategory(),
          this._color.name,
          this._page,
          this._pageSize,
          this._searchString
      );
  };
  public getIcons() {
      return new Promise((resolve, reject) => {
          const id = this._iconStore.getLastChangeId();
          if (id !== this._lastChangeId) {
              this._updateIcons();
          }
          resolve(this._icons);
      });
  }
  public getIconsOld() {
      const id = this._iconStore.getLastChangeId();
      if (id !== this._lastChangeId) {
          this._updateIcons();
      }
      return this._icons;
  }
  public setCategory(category) {
      this._category = category;
      this._page = 1;
      this._updateIcons();
  }
  public setColor(color) {
      this._color = color;
      this._updateIcons();
  }
  public setPageSize(pageSize) {
      this._pageSize = pageSize;
      this._updateIcons();
  }
  public gotoFirstPage() {
      this._page = 1;
      this._updateIcons();
  }
  public gotoPage(pageNum) {
      if (
          pageNum >= 1
      && pageNum
        <= this._iconStore.getLastPageNumber(
            this._getCategory(),
            this._color.name,
            this._pageSize,
            this._searchString
        )
      ) {
          this._page = pageNum;
          this._updateIcons();
      }
  }
  public gotoLastPage() {
      this._page = this._iconStore.getLastPageNumber(
          this._getCategory(),
          this._color.name,
          this._pageSize,
          this._searchString
      );
      this._updateIcons();
  }
  public getPageNumbers() {
      return this._iconStore.getPageNumbers(
          this._getCategory(),
          this._color.name,
          this._page,
          this._pageSize,
          this._maxPageDisplayCount,
          this._searchString
      );
  }
  public getCategories() {
      return this._categories;
  }
  public getColors() {
      return this._colors;
  }
  public getColorsHex() {
      return this._iconStore.getColorsHex();
  }
  public needsPaging() {
      return (
          this._iconStore.getLastPageNumber(
              this._getCategory(),
              this._color.name,
              this._pageSize,
              this._searchString
          ) > 1
      );
  }
  public getCurrentCategory() {
      return this._category;
  }
  public getCurrentColor() {
      return this._color;
  }
  public getCurrentColorHex() {
      return this._iconStore.getColorHex(this._color.name);
  }
  public getCurrentPageNumber() {
      return this._page;
  }
  public setMaxPageDisplayCount(count) {
      this._maxPageDisplayCount = count;
  }
  public getIcon(name) {
      return this._iconStore.getIcon(this._getCategory(), this._color.name, name);
  }
  public setSearchString(searchString) {
      this._searchString = searchString;
      this._updateIcons();
  }
  public gotoNextPage() {
      this.gotoPage(this._page + 1);
  }
  public gotoPreviousPage() {
      this.gotoPage(this._page - 1);
  }
}

const getOtherStoreColumnValue = (info: IOtherInformation) => {
    const {
        otherValueDate,
        otherValueInteger,
        otherValueNumber,
        otherValueString,
    } = info;

    return otherValueDate
        ? moment(otherValueDate).format("M/D/YYYY hh:mm")
        : otherValueInteger
            ? otherValueInteger
            : otherValueNumber
                ? otherValueNumber
                : otherValueString
                    ? otherValueString
                    : null;
};

export const getStoreColumns = (storeData: IStore[], companyType: CompanyType): any[] => {
    const otherInfoColumnTitles: string[] = [];
    const newColumns: any[] = [];

    storeData = storeData.filter(
        (store: IStore) => store.otherInformation.length > 0
    );

    storeData.forEach((store: IStore) =>
        store.otherInformation.forEach((info: IOtherInformation) =>
            otherInfoColumnTitles.indexOf(info.otherName) == -1
                ? otherInfoColumnTitles.push(info.otherName)
                : null
        )
    );

    if (otherInfoColumnTitles.length > 0) {
        otherInfoColumnTitles.forEach((columnName: string) => {
            newColumns.push({
                title: columnName,
                width: 200,
                dataIndex: null,
                isChecked: true,
                render: (store: IStore) => {
                    return store.otherInformation.map((info: IOtherInformation) => {
                        if (info.otherName === columnName) {
                            return <span>{getOtherStoreColumnValue(info)} </span>;
                        }
                    });
                },
            });
        });
    }

    const storeCols = storeColumns(companyType);

    return [...storeCols].concat(newColumns);
};

// Compare 2 arrays
export const deepEqualArray = (arr1: any[], arr2: any[]): boolean => {
    if (arr1 === arr2) {
        return true;
    }
    if (!arr1 || !arr2 || arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        if (!deepEqualObject(arr1[i], arr2[i])) {
            return false;
        }
    }

    return true;
};

// Compare 2 objects
const deepEqualObject = (obj1: Record<string, any>, obj2: Record<string, any>): boolean => {
    if (obj1 === obj2) {
        return true;
    }
    if (!obj1 || !obj2) {
        return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        const val1 = obj1[key];
        const val2 = obj2[key];

        const areObjects = isObject(val1) && isObject(val2);
        if (
            (areObjects && !deepEqualObject(val1, val2))
            || (!areObjects && val1 !== val2)
        ) {
            return false;
        }
    }

    return true;
};

const isObject = (obj: any): boolean => obj !== null && typeof obj === "object";
